<template>
  <div class="ui-article-item-wrapper" @click.stop="_jumpArticle">
    <div class="left">
      <img v-lazy="articleImg" class="article-img" />
    </div>
    <div class="right">
      <div class="title">{{ articleInfo.title }}</div>
      <div class="time">{{ articleInfo.publishtime | resolveTime }}</div>
    </div>
  </div>
</template>

<script>
import jumpArticle from "@/mixins/jumpArticle"

export default {
  name: "uiArticleItem",
  props: {
    articleInfo: {
      type: Object,
      default() {
        return {}
      }
    },
    isPC: {
      type: Boolean,
      default: false
    }
  },
  filters: {
    resolveTime(value) {
      if (!value) return ""
      const MESC_30MIN = 1800000
      value = value.toString()
      value = value.split(".")[0].replace(/-/g, "/")
      let pubDate = new Date(value)
      let nowDate = new Date()
      let ret = ""
      let pubDateMon = pubDate.getMonth().toString().length < 2 ? "0" + pubDate.getMonth().toString() : pubDate.getMonth().toString()
      let pubDateDate = pubDate.getDate().toString().length < 2 ? "0" + pubDate.getDate().toString() : pubDate.getDate().toString()
      let nowDateMon = nowDate.getMonth().toString().length < 2 ? "0" + nowDate.getMonth().toString() : nowDate.getMonth().toString()
      let nowDateDate = nowDate.getDate().toString().length < 2 ? "0" + nowDate.getDate().toString() : nowDate.getDate().toString()
      let pubDateNum = pubDate.getFullYear() + "" + pubDateMon + "" + pubDateDate
      let nowDateNum = nowDate.getFullYear() + "" + nowDateMon + "" + nowDateDate
      let pubDateMinu = pubDate.getTime()
      let nowDateMinu = nowDate.getTime()
      let minuDis = nowDateMinu - pubDateMinu

      let isBeforeYesterday = nowDateNum - pubDateNum >= 1
      if (isBeforeYesterday) {
        ret = pubDate.getFullYear() + "-" + (parseInt(pubDate.getMonth()) + 1) + "-" + pubDate.getDate()
      } else {
        let reg = /.+\s(\d+:\d+):\d+(\.\d+)?/g
        ret = value.replace(reg, (p1, p2) => {
          return p2
        })
        // 30分钟之前显示刚刚
        if (minuDis <= MESC_30MIN) {
          ret = "刚刚"
        }
        // else if (minuDis <= 300000) {
        //   ret = `${Math.ceil(minuDis / 60000)}分钟前`
        // }
      }
      return ret
    }
  },
  mixins: [jumpArticle],
  methods: {
    _jumpArticle() {
      this.jumpArticle(this.articleInfo)
    }
  },
  computed: {
    articleImg() {
      return this.isPC ? this.articleInfo.picMiddle : this.articleInfo.picSmall ? this.articleInfo.picSmall : this.articleInfo.picMiddle ? this.articleInfo.picMiddle : ""
    }
  }
}
</script>

<style lang="scss" scoped>
.ui-article-item-wrapper {
  display: flex;
  margin-bottom: 0.4rem;
  &:last-child {
    margin-bottom: 0;
  }
  .left {
    width: 2rem;
    height: 1.5rem;
    border: 1px solid #eeeeee;
    border-radius: 0.04rem;
    overflow: hidden;
    flex: none;
    margin-right: 0.2rem;
    .article-img {
      width: 100%;
      height: 100%;
    }
  }
  .right {
    .title {
      font-family: PingFang-SC-Bold;
      font-size: 0.3rem;
      color: #333333;
      line-height: 0.4rem;
      min-height: 0.93rem;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 3;
      overflow: hidden;
      margin-bottom: 0.2rem;
    }
    .time {
      font-family: PingFangSC-Regular;
      font-size: 0.24rem;
      color: #999999;
      line-height: 0.34rem;
    }
  }
}
.pc .ui-article-item-wrapper {
  background: #ffffff;
  border: 1px solid #dddddd;
  border-radius: 6px;
  margin-bottom: 0;
  width: 260px;
  height: 250px;
  display: flex;
  flex-direction: column;
  margin-right: 33px;
  overflow: hidden;
  &:last-child {
    margin-right: 0;
  }
  .left {
    width: 100%;
    height: 146.25px;
    margin-right: 0;
    border: none;
  }
  .right {
    margin-top: 16px;
    padding: 0 16px;
    .title {
      font-family: PingFangSC-Semibold;
      font-size: 16px;
      color: #333333;
      line-height: 22px;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;
      overflow: hidden;
      margin-bottom: 10px;
      height: 44px;
    }
    .time {
      font-family: PingFangSC-Regular;
      font-size: 14px;
      color: #999999;
      line-height: 24px;
    }
  }
}
</style>
